module.exports = {
	"id": "GH",
	"name": "Ghana",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": 0.002927,
			"10": null,
			"11": 0.032197,
			"12": null,
			"13": 0.002927,
			"14": 0.002927,
			"15": null,
			"16": 0.005854,
			"17": 0.005854,
			"18": 0.005854,
			"19": 0.005854,
			"20": 0.008781,
			"21": 0.005854,
			"22": 0.008781,
			"23": 0.011708,
			"24": 0.002927,
			"25": 0.014635,
			"26": 0.005854,
			"27": 0.014635,
			"28": 0.011708,
			"29": 0.020489,
			"30": 0.011708,
			"31": 0.040978,
			"32": 0.020489,
			"33": 0.055613,
			"34": 0.008781,
			"35": 0.023416,
			"36": 0.017562,
			"37": 0.005854,
			"38": 0.008781,
			"39": 0.017562,
			"40": 0.02927,
			"41": 0.008781,
			"42": 0.014635,
			"43": 0.231233,
			"44": 0.017562,
			"45": 0.064394,
			"46": 0.032197,
			"47": 0.084883,
			"48": 0.040978,
			"49": 0.441977,
			"50": 0.070248,
			"51": 0.456612,
			"52": 0.283919,
			"53": 8.101936,
			"54": 2.154272,
			"55": 0.125861,
			"56": 0.032197,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.073175,
			"4": 0.017562,
			"5": 0.011708,
			"6": 0.005854,
			"7": 0.005854,
			"8": 0.005854,
			"9": 0.005854,
			"10": 0.014635,
			"11": 0.032197,
			"12": 0.023416,
			"13": 0.014635,
			"14": 0.014635,
			"15": 0.026343,
			"16": 0.023416,
			"17": 0.011708,
			"18": 0.011708,
			"19": 0.011708,
			"20": 0.020489,
			"21": 0.023416,
			"22": 0.014635,
			"23": 0.017562,
			"24": 0.017562,
			"25": 0.011708,
			"26": 0.017562,
			"27": 0.017562,
			"28": 0.017562,
			"29": 0.064394,
			"30": 0.05854,
			"31": 0.032197,
			"32": 0.02927,
			"33": 0.035124,
			"34": 0.049759,
			"35": 0.05854,
			"36": 0.064394,
			"37": 0.073175,
			"38": 0.08781,
			"39": 0.081956,
			"40": 0.140496,
			"41": 0.143423,
			"42": 0.099518,
			"43": 0.456612,
			"44": 0.389291,
			"45": 0.216598,
			"46": 0.207817,
			"47": 0.93664,
			"48": 0.945421,
			"49": 4.168048,
			"50": 1.039085,
			"51": 0.011708,
			"52": 0.002927,
			"3.5": null,
			"3.6": 0.020489
		},
		"opera": {
			"9": null,
			"11": 0.005854,
			"12": 0.005854,
			"15": 0.005854,
			"16": 0.002927,
			"17": 0.005854,
			"18": 0.005854,
			"19": null,
			"20": 0.005854,
			"21": 0.002927,
			"22": 0.002927,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.002927,
			"29": 0.026343,
			"30": 0.005854,
			"31": 0.008781,
			"32": 0.005854,
			"33": 0.011708,
			"34": 0.011708,
			"35": 0.02927,
			"36": 0.02927,
			"37": 0.280992,
			"38": 0.023416,
			"39": 0.043905,
			"40": 0.699553,
			"41": 0.08781,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": 0.002927,
			"11.1": null,
			"11.5": 0.008781,
			"11.6": 0.011708,
			"12.1": 0.020489
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.005854,
			"6": 0.002927,
			"7": 0.008781,
			"8": 0.043905,
			"9": 0.079029,
			"10": 0.269284,
			"3.1": null,
			"3.2": null,
			"5.1": 0.020489,
			"6.1": 0.005854,
			"7.1": 0.008781,
			"9.1": 0.216598
		},
		"ios_saf": {
			"8": 0,
			"10": 1.66786731057,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0449470940883,
			"8.1-8.4": 0.0830378517902,
			"9.0-9.2": 0.03961438801,
			"9.3": 0.604373355537
		},
		"android": {
			"3": 0,
			"4": 0.0839137571059,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0104892196382,
			"4.1": 0.302688909561,
			"4.2-4.3": 0.756722273902,
			"4.4": 1.73521662016,
			"4.4.3-4.4.4": 1.75020121964
		},
		"ie": {
			"6": 0.00886502870813,
			"7": 0.00295500956938,
			"8": 0.180255583732,
			"9": 0.0413701339713,
			"10": 0.127065411483,
			"11": 0.848087746411,
			"5.5": null
		},
		"op_mob": {
			"0": 2.91988281281,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0811078559114
		},
		"edge": {
			"12": 0.193182,
			"13": 0.201963,
			"14": 0.260503
		},
		"ie_mob": {
			"10": 0.372325859155,
			"11": 1.51589814085
		},
		"bb": {
			"7": 0.063648,
			"10": null
		},
		"samsung": {
			"0": 1.265888
		},
		"and_uc": {
			"0": 5.989984
		},
		"op_mini": {
			"0": 39.3390733313
		},
		"and_chr": {
			"0": 13.117562
		},
		"and_ff": {
			"0": 0.056576
		}
	},
	"total": 98.1349849139
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/GH.json
 ** module id = 530
 ** module chunks = 0
 **/